var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurplleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_432_3890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41798 18.9437C14.5052 18.9437 18.6289 14.8199 18.6289 9.7327C18.6289 4.6455 14.5052 0.521753 9.41798 0.521753C4.33077 0.521753 0.207031 4.6455 0.207031 9.7327C0.207031 14.8199 4.33077 18.9437 9.41798 18.9437Z",
    fill: "#7956D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.3282L7.63196 12.7102L13.5869 6.75525",
    stroke: "white",
    strokeWidth: 1.41707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_432_3890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.4219,
    height: 18.4219,
    fill: "white",
    transform: "translate(0.207031 0.521753)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurplleCircle);
export default __webpack_public_path__ + "static/media/purplleCircle.b63c2625ed1b6b8ecee010b1e10d827d.svg";
export { ForwardRef as ReactComponent };